import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { pickupPoints } from "../../../../../../../redux/pickup-points/action";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { selectPickupPointsListItems } from "../../../../../../../redux/pickup-points/selector";
import Table from "../../../../../../../common/components/table";
import PageLoader from "../../../../../../../components/PageLoader";

const ManagementPickupPoints = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const navigate = useNavigate()
    const pickupPointItems = useSelector(selectPickupPointsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'PickupPointInfo.Name', headerName: 'Name' },
      { field: 'PickupPointInfo.Description', headerName: 'Description' },
      { field: 'PickupPointInfo.PickupFee', headerName: 'PickupFee' },
      { field: 'PrimaryAddress.Address1', headerName: 'Address1' },
      { field: 'PrimaryAddress.Address2', headerName: 'Address2' },
      { field: 'PrimaryAddress.City', headerName: 'City' },
      { field: 'PrimaryAddress.FaxNumber', headerName: 'FaxNumber' }
        ]);
      }
      const fetchPickupPoints=()=>{

        dispatch(pickupPoints.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points/list`,entity:'pickupPoints',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchPickupPoints()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add Pickup Points',
      callback: () => handleAdd(),
    },
    {
      name: 'Go To Store',
      callback: () => handleStore(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleStore=()=>{
    navigate('/management/organization/organization-management/stores')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.PickupPointInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(pickupPoints.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points/delete`,
      entity: 'pickupPoints',
      jsonData: {
          Records: [
              {
                  Id: data?.PickupPointInfo?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(pickupPoints.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/store/pickup-points/list`,entity:'pickupPoints',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {pickupPointItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={pickupPointItems?.result?.items} setPageData={setPageData}
    paginationData={pickupPointItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Pickup Points"  />
  }
  </> 
     
	);
};

export default ManagementPickupPoints;


